import makeRequest, {HttpMethod} from "./request";

const listAdminModulesActions = makeRequest('list-admin-modules-actions').prepare(async (params: object) => {
    const { data: processedData, response, method } = params as { data: any; response: any, method: HttpMethod };
    // const processedData = data?.data;
    return { data: processedData, response, method };
});

export default listAdminModulesActions;